import { useEffect } from 'react';

import { format } from 'date-fns';
import { is } from 'date-fns/locale';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import WebFont from 'webfontloader';

import { useStore } from 'models/Provider';

import clock from './clock.svg';
import jobLogo from './job-dot-is.png';

export const PromoteJobDotIsExample = observer((props) => {
  const {
    state,
    //boardState,
    job,
  } = props;
  const { current } = useStore();

  useEffect(() => {
    WebFont.load({
      google: {
        families: ['Open Sans:400,600', 'Roboto:600'],
      },
    });
  }, []);

  return (
    <Container>
      <Header>
        <img height={60} src={jobLogo} alt="Job.is" />
      </Header>
      {job.deadline && (
        <Deadline>
          <img src={clock} height="auto" width={20} alt="expiry" />
          Starf rennur út {format(new Date(job.deadline), 'dd. MMMM yyyy.', { locale: is })}
        </Deadline>
      )}
      <Content>
        <ContentHeader>
          <Logo>
            <img src={current.info.logo} alt={current.info.companyName} />
          </Logo>
          <div>
            <h2>{state.data.title}</h2>
            <div>
              <CompanyName>{current.info.companyName}</CompanyName>
              <Location />
              <div>
                {job.location?.translations.find((lt) => lt.language === state.language)?.title}
              </div>
            </div>
          </div>
        </ContentHeader>

        <Description dangerouslySetInnerHTML={{ __html: state.data.description }} />

        <ApplyButton>Sækja um</ApplyButton>
      </Content>
    </Container>
  );
});

const ApplyButton = styled.button({
  background: '#0097f9',
  textTransform: 'uppercase',
  width: 200,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '5px',
  height: 50,
  color: '#fff',
  fontWeight: 600,
  fontSize: 16,
  marginTop: 30,
});

const Description = styled.div({
  marginTop: 40,
  p: {
    lineHeight: 1.7,
    margin: '0 0 1.5rem 0',
    color: '#3c3c3c',
    fontSize: 16,
  },
  ul: {
    listStyle: 'disc',
    margin: '0 0 40px 20px',
    padding: 0,
    fontSize: 16,
  },
  li: {
    lineHeight: '1.9',
  },
});

const Deadline = styled.div({
  height: 40,
  width: '100%',
  background: '#7dc146',
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  img: {
    marginRight: 10,
  },
});

const CompanyName = styled.div({
  color: '#71a5cb',
  marginLeft: 0,
  marginRight: 10,
});

const ContentHeader = styled.div({
  display: 'flex',
  '> div:nth-child(2)': {
    marginLeft: 20,
    '> div': {
      display: 'flex',
      alignItems: 'center',
      color: '#adadad',
      marginTop: 10,
      '*': {
        marginLeft: 5,
      },
    },
  },
  h2: {
    color: '#000',
    fontWeight: 600,
    fontSize: 42,
    fontFamily: '"Roboto", sans-serif !important',
    lineHeight: 1,
  },
});

const Logo = styled.div({
  height: 120,
  width: 120,
  border: '1px solid #efefef',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  img: {
    height: 'auto',
    maxWidth: '100%',
  },
});

const Content = styled.div({
  background: '#fff',
  width: '100%',
  padding: '50px 30px',
});

const Header = styled.div({
  height: 120,
  background: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 30px',
  borderBottom: '1px solid #f3f3f3',
  boxShadow: '3px 3px 5px rgba(102,102,102,0.09)',
});

const Container = styled.div({
  '*': {
    fontFamily: '"Open Sans", sans-serif !important',
  },
  overflow: 'hidden',
});

const Location = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 395 395"
    fill="#adadad"
  >
    <path d="M197.849 0C122.131 0 60.531 61.609 60.531 137.329c0 72.887 124.591 243.177 129.896 250.388l4.951 6.738a3.064 3.064 0 002.471 1.255 3.08 3.08 0 002.486-1.255l4.948-6.738c5.308-7.211 129.896-177.501 129.896-250.388C335.179 61.609 273.569 0 197.849 0zm0 88.138c27.13 0 49.191 22.062 49.191 49.191 0 27.115-22.062 49.191-49.191 49.191-27.114 0-49.191-22.076-49.191-49.191 0-27.129 22.076-49.191 49.191-49.191z" />
  </svg>
);
